'use client'

import { ZapIcon } from 'lucide-react'

import { AccountBanner } from '~/components/account-detail/AccountBanner'
import { Skeleton } from '~/components/component-library/Skeleton'
import { EnableAutoEarnDialogContent } from '~/components/forms/earn/EnableAutoEarnDialog'
import { useAutoEarnToggle } from '~/components/forms/earn/useAutoEarnToggle'
import { useAuth } from '~/context/AuthProvider'
import { useAutoEarnApy } from '~/hooks/useAutoEarnApy'
import { OrgSmartAccount } from '~/types'
import { getEarnLabel } from '~/utils/vault'

export const EarnApyBanner = ({
  smartAccount,
}: {
  smartAccount: OrgSmartAccount
}) => {
  const { apy, isLoading: isApyLoading } = useAutoEarnApy()
  const { setGlobalModalState, closeGlobalModal } = useAuth()
  // Signer-gated like every auto-earn surface; blocked clicks keep the normal look
  const { isDisabled, disabledReason } = useAutoEarnToggle(smartAccount)

  return (
    <AccountBanner
      icon={<ZapIcon className="h-6 w-6 text-white" />}
      title={
        isApyLoading ? (
          <div className="flex items-center space-x-1">
            <div>Earn</div> <Skeleton size="sm" length={3} height={0.5} />
          </div>
        ) : (
          getEarnLabel(apy)
        )
      }
      description="Auto-deposit your idle USDC"
      isDisabled={isDisabled}
      disabledReason={disabledReason}
      onClick={() => {
        setGlobalModalState({
          isOpen: true,
          content: (
            <EnableAutoEarnDialogContent
              smartAccount={smartAccount}
              closeDialog={closeGlobalModal}
            />
          ),
        })
      }}
    />
  )
}
